import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';
import { actions } from '..';

const STORE = 'prematter';
const prematterThunk = {
  fetchById: createAsyncThunk(
    `${STORE}/fetchById`,
    async (args: { id: string }, { rejectWithValue }) => {
      try {
        const { id } = args;
        const response = await api.prematter.fetchById({ id });
        return response;
      } catch (error) {
        console.error('fetch connection by id', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  fetchByConnectionId: createAsyncThunk(
    `${STORE}/fetchByConnectionId`,
    async (args: { connectionId: string }, { rejectWithValue }) => {
      try {
        const { connectionId } = args;
        const response = await api.prematter.fetchByConnectionId({
          connectionId,
        });
        return response;
      } catch (error) {
        console.error('fetch connection by id', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
  convertToMatter: createAsyncThunk(
    `${STORE}/convertToMatter`,
    async (args: { id: string }, { rejectWithValue, dispatch }) => {
      try {
        const { id } = args;
        const response = await api.prematter.convertToMatter({ id });
        dispatch(actions.lawyerConnection.fetchById({ id }));
        return response;
      } catch (error) {
        console.error('convert to matter', error);
        return rejectWithValue(error.message as string);
      }
    }
  ),
};

export default prematterThunk;
